<template>
  <div class="join-form--container">
    <div class="join-form--wrapper">
      <component :is="stepComponent"
        :step.sync="step"
        :form.sync="form"
        :options="options"
        :prices="prices"
        :discount="discount"
        :loading="loading"
        :error="error"
        @clear="doClear"
        @process="doProcess"
      />
    </div>
    <iframe 
      v-if="iframe3DS" 
      :src="iframe3DS"
      class="join-form--iframe-3ds"
      frameborder="0">
    </iframe>
    <!-- <div class="join-form--contact-us">
      <div>
        <strong>Need assistance? Contact us</strong>
      </div>
      <a href="tel:1300133655">
        <i class="fas fa-phone-alt"></i>
        1300 133 655
      </a>
    </div> -->
  </div>
</template>
<script>
  import NoEnable from '../components/join/NoEnable';
  import StepOne from '../components/join/StepOne';
  import StepTwo from '../components/join/StepTwo';
  import StepThree from '../components/join/StepThree';
  import StepFour from '../components/join/StepFour';
  import StepFive from '../components/join/StepFive';
  import StepSix from '../components/join/StepSix';
  import StepSeven from '../components/join/StepSeven';

  export default {
    name: 'join-form',
    props: ['options'],
    components: {
      NoEnable, 
      StepOne,
      StepTwo,
      StepThree,
      StepFour,
      StepFive,
      StepSix,
      StepSeven,
    },
    data() {
      return {
        step: 1,
        loading: false,
        error: false,
        iframe3DS: false,
        form: {
          state: '',
          prefix: '',
          name: '',
          lastname: '',
          email: '',
          password: '',
          day: '',
          month: '',
          year: '',
          stage: '',
          employment: '',
          membership: '',
          origin: '',
          phone: '',
          university: '',
          current_year: '',
          start_year: '',
          end_year: '',
          interest: '',
          craft: '',
          gender: '',
          practice_groups: [],
          sa_communication: [],
          sa_medicSA: [],
          ahpra: '',
          reason: '',
          outside: '',
          practice: '',
          addressString: '',
          address: {
            address_1: '',
            address_2: '',
            state: '',
            postcode: '', 
          },
          partner_rate: 0,
          businessAddress: '',
          business_address: null,
          referral: '',
          payment: 'M',
          paymentType: 'cc',
          postal_address: '',
          price: 0,
          imis: '',
          etf: {
            name: '',
            number: '',
            bsb: '',
          },
          card: {
            type: '',
            name: '',
            number: '',
            expiry: '',
            ccv: '',
          },
          ama_member: '',
          ama_referee:'',
          emp_as: '',
          hospitalEmp: '',
          professional_groups: [],
          paterner_ama: '',
          workpaceSetting: '', //QLD
          asmof: 'Yes', //TAS, NT
          dit_date: '', //NSW
          dit_intern: '',
          offerdiscount: '',
          //cpd_sub: '', //SA
          imis_id: '', //tracking the new member through the join process
          promoteCode: '', //NSW promotion code for DIT GP & SPEC 
        }
      }  
    },
    computed: {
      stepComponent() {
        switch(this.step) {
          case -1:
            return 'NoEnable';
          case 1:
            return 'StepOne';
          case 2:
            return 'StepTwo';
          case 3:
            return 'StepThree';
          case 4:
            return 'StepFour';
          case 5:
            return 'StepFive';
          case 6:
            return 'StepSix';
          case 7:
            return 'StepSeven';
        }
        return 'StepOne';
      },
      prices() {
        const prices = this.options.prices;
        console.log(prices)
        const { state, membership } = this.form;
        //This is for NSW F1PT membership type
        /**const dit_intern = this.data.dit_intern;**/
        if(this.form.dit_intern) {
          return prices[state]['F1PT'];
        }
        
        if(this.form.offerdiscount == 'internWebinar2024') {
          return prices[state]['F1Y1 - 25% OFF'];
        }

        /**if (this.form.cpd_sub) {
          switch (this.form.membership) {
          case "F2Y1":
            return prices[state]['F2Y1 - 50% OFF'];
          case "F3Y1":
            return prices[state]['F3Y1 - 50% OFF'];
          case "F4Y1":
            return prices[state]['F4Y1 - 50% OFF'];
          case "F5Y1":
            return prices[state]['F5Y1 - 50% OFF'];
          default:
            break;
          }
          
        }**/

        if (prices && prices[state] && prices[state][membership]) {
          return prices[state][membership];
        }

        return {};
      },
      discount() {
        if (!this.form.partner_rate) {
          return 0;
        }

        if (this.form.state !== 'SA') {
          return 0;
        }

        return 0.15;
      }
    },
    methods: {
      doClear() {
        this.error = false;
      },
      async doProcess() {
        this.loading = true;
        await this.$recaptchaLoaded() 
        const token = await this.$recaptcha('submit')
        const isStudent = this.form.stage == 'student';
        const isCard = this.form.paymentType == 'cc';
        let data = {...this.form};
        data.card = {...this.form.card};
        data.captcha = token;
        data.join_year = window.metadata.year;
        data.imisid = window.localStorage.getItem('imisid') || null;   //verify the finally payment process has been went through
        data.paymentMethodId = window.localStorage.getItem('paymentMethodId') || null;
        //data.membership = isStudent ? 'F1S1' : this.form.membership;
        if(isStudent) {
          data.membership = 'STUD';
          data.current_year = 'STUD';
        }

        for(let item of this.options.employHos) {
          if(data.hospitalEmp == 1){
            data.hospitalEmp = ''
          }
          if(data.hospitalEmp == item.id){
            data.hospitalEmp = item.label
          }
        }
  
        if(data.state != 'NT' && data.state != 'TAS') {
          data.asmof = ''
        }

        if (!isStudent) {
          data.price = this.prices[this.form.payment]['price'];
          data.stripeCode = this.prices[this.form.payment]['stripe'] || null;
          this.$set(this.form, 'price', data.price);
          data.card.number = isCard ? data.card.number.replaceAll(' ', '') : '';
        }

        console.log("join data before post: ", data);
        window.apiJoin.post('', data).then(response => {
          this.loading = false;

          if (response.data.imisID) {
            window.localStorage.setItem('imisid', response.data.imisID);
          }

          if (response.data.action) {
            this.loading = true;
            window.localStorage.setItem('paymentMethodId', response.data.paymentMethodId);
            this.iframe3DS = response.data.action;
            return;
          }

          if (response.data.success) {
            window.localStorage.removeItem('paymentMethodId');
            window.localStorage.removeItem('imisid');
            this.form.imis = response.data.imis;
            this.step = 7;
            return;
          }
          
          if (this.form.stage == 'student') {
            alert('Something went wrong, please contact suppport.')
            return;
          }

          this.error = response.data.payment? 'error' : true;
        });
      },
    },
    mounted() {
      // Remove any localStorage on load
      window.localStorage.removeItem('paymentMethodId');

      //This is a code for shortcutting the join process for state or career stage when people access membership?state=NSW&careerStage=dit
      //const states = ['SA', 'NSW', 'QLD', 'TAS', 'ACT', 'NT'];
      // if (window.metadata.state) {
      //   this.form.state = window.metadata.state;
      //   const isValid = states.includes(window.metadata.state)
      //   this.step = isValid ? 2 : -1;
      // }

      window.addEventListener("message", (event) => {  
        if (event.data &&  (!event.data.imisId || event.data.imisId != window.localStorage.getItem('imisid'))) {
          return;
        }

        if (event.data && event.data.status == 'succeeded') {
          this.doProcess();
          return;
        }

        window.localStorage.removeItem('paymentMethodId');
        this.loading = false;
        this.error = true;
        this.iframe3DS = false;
      }, false);
    }
  }
</script>